module.exports = __webpack_public_path__ + "ofis-1.jpeg?74366336899abc08c188887c5c6b6c53";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/ofis-1.jpeg
// module id = 352
// module chunks = 0